import { Box, Flex, Spinner } from '@ouster/webviz-react-components';

import { ReactNode } from 'react';

interface SummaryCardProps {
  title: string;
  icon: ReactNode;
  allTimeValue: number | null;
  rangeValue: number | null;
  isLoadingAllTime: boolean;
  isLoadingRange: boolean;
  rangeLabel: string;
}

export default function SummaryCard({
  title,
  icon,
  allTimeValue,
  rangeValue,
  isLoadingAllTime,
  isLoadingRange,
  rangeLabel,
}: SummaryCardProps) {
  return (
    <Box
      bg="gray.800"
      p={6}
      borderRadius="lg"
      border="1px solid"
      borderColor="gray.700"
      flex="1"
      minW="300px"
    >
      <Flex alignItems="center" gap={3} mb={4} placeContent="space-between">
        <Box
          as="p"
          fontSize="sm"
          fontWeight="bold"
          color="gray.300"
          textTransform="uppercase"
        >
          {title}
        </Box>
        <Box
          fontSize="24px"
          color="gray.400"
          display={{ base: 'none', md: 'block' }}
        >
          {icon}
        </Box>
      </Flex>
      <Flex alignItems="flex-start" gap={{ base: 4, md: 8 }}>
        <Box flex="1" w={{ base: 'full', md: 'auto' }}>
          <Box as="p" fontSize="xs" color="gray.400" mb={1}>
            All-time
          </Box>
          {isLoadingAllTime ? (
            <Box display="flex" justifyContent="flex-start">
              <Spinner size="md" />
            </Box>
          ) : (
            <Box
              as="p"
              fontSize={{ base: '20px', lg: '28px' }}
              fontWeight={{ base: 'bold', lg: 'semibold' }}
              color="white"
              lineHeight="1.1"
            >
              {allTimeValue?.toLocaleString() || '0'}
            </Box>
          )}
        </Box>

        <Box flex="1" w={{ base: 'full', md: 'auto' }}>
          <Box as="p" fontSize="xs" color="gray.400" mb={1}>
            {rangeLabel}
          </Box>
          {isLoadingRange ? (
            <Box display="flex" justifyContent="flex-start">
              <Spinner size="md" />
            </Box>
          ) : (
            <Box
              as="p"
              fontSize={{ base: '20px', lg: '28px' }}
              fontWeight={{ base: 'bold', lg: 'semibold' }}
              color="gray.100"
              lineHeight="1.1"
            >
              {rangeValue?.toLocaleString() || '0'}
            </Box>
          )}
        </Box>
      </Flex>
    </Box>
  );
}
